<div class="overall-container">
  <app-toast></app-toast>
  <app-popup-message></app-popup-message>

  <app-order-countdown [expiryTime]="expiryTime" [serverTime]="serverTime" (onShowExpiryDate)="onShowExpiryDate($event)"
    (onTimeup)="onTimeup()" *ngIf="isDisplayQRExpired && isShowQrExpired"></app-order-countdown>

  <app-header (onOrderTypeLocation)="onClickOrderTypeLocation()" [showMobileHeader]="showMobileHeader"
    *ngIf="showMobileHeader" flexLayout="column">
  </app-header>

  <div flexLayout="row" fxFlex>
    <div class="router-content" [ngStyle]="{ 'padding-bottom': showMobileBottomNav? '40px': '0px'}"
      [style.background-color]="curRouter === 'home' ? 'var(--general-body-secondary)' : 'var(--general-body-primary)'">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer [showMobileBottomNav]="showMobileBottomNav" *ngIf="showMobileBottomNav"
    [isFinishedLoading]="isFinishedLoading" flexLayout="column"></app-footer>
</div>

<p-dialog position="bottom" [(visible)]="displayOrderTypeAdressDialog" *ngIf="displayOrderTypeAdressDialog"
  [modal]="true" [dismissableMask]="false" [blockScroll]="true" styleClass="orderTypeAdressDialog">

  <div class="orderTypeAdress-container">
    <app-order-type (onOrderTypeChanged)="mobileOrderTypeChanged($event)"></app-order-type>

    <ng-template [ngIf]="channelOrderType !== orderTypeFlag.DineIn || !shareTable">
      <div class="fulladdress-container" (click)="onClickLocation()">
        <label [ngClass]="{'value-label': fulladdress}">{{'label.delivery.address' | translate}}</label>
        <h1 class="truncateText fulladdress" *ngIf="fulladdress">{{fulladdress}}</h1>
      </div>

    </ng-template>
    <!--dine in: table no-->
    <ng-template [ngIf]="channelOrderType === orderTypeFlag.DineIn && shareTable">
      <app-location-search></app-location-search>
    </ng-template>

    <app-button [buttonName]="'button.done' | translate" (onClickEvent)="mobileOrderTypeDoneAction()"></app-button>
  </div>
</p-dialog>

<p-dialog position="bottom" *ngIf="displayAddressDialog" [(visible)]="displayAddressDialog" [modal]="true"
  [dismissableMask]="true" [blockScroll]="true" styleClass="fullScreen-dialog"
  (onShow)="setAddressDialogVisibility(true)" (onHide)="setAddressDialogVisibility(false)">

  <app-address *ngIf="displayAddress" [savedAddress]="savedAddress" [updateAddressSuccess]="updateAddressSuccess"
    [orderType]="channelOrderType" [tableNoReq]="shareTable" (displayAddAddressForm)="displayAddAddressForm($event)"
    (editSelectedAddress)="editSelectedAddress($event)" (deleteSelectedAddress)="deleteSelectedAddress($event)"
    (closeDialog)="closeDialog()" (onQuitAddress)="setAddressDialogVisibility(false)">
  </app-address>

  <app-address-form *ngIf="displayAddAddress" (onSubmitAddAddress)="onSubmitAddAddress($event)"
    (onBackPreviousPage)="onClickCloseDialog()" (onUpdateAddress)="onUpdateAddress($event)"
    [editSelectedAddress]="editUserAddress" [savedNewAddress]="localSavedNewAddress" [isHome]="true">
  </app-address-form>
</p-dialog>

<p-dialog position="bottom" [(visible)]="displayScanner" [baseZIndex]="999999999999" *ngIf="displayScanner"
  [modal]="true" [dismissableMask]="true" [blockScroll]="true" styleClass="fullScreen-dialog qr-scanner-dialog">
  <app-qr-scanner [isGeneralScan]="qrScannerData.isGeneralScan" [showHeaderDesc]="qrScannerData.headerDesc"
    [channelId]="channelId" (closeDialog)="displayScanner = false"></app-qr-scanner>
</p-dialog>

<p-dialog position="center" [(visible)]="displayQuitQrDineMessage" [baseZIndex]="999999999999"
  *ngIf="displayQuitQrDineMessage" [modal]="true" [dismissableMask]="true" [blockScroll]="true"
  styleClass="centerScreen-dialog">
  <app-qr-quit-message (clickNo)="closeQuitQrDialog()" (clickYes)="quitQrDineInMode()"
    [channelId]="channelId"></app-qr-quit-message>
</p-dialog>

<p-dialog position="center" [(visible)]="displayQrPopup" *ngIf="displayQrPopup" [modal]="true" [dismissableMask]="false"
  [blockScroll]="true" styleClass="fullScreen-dialog displayQrPopup-dialog">
  <app-mobile-header [title]="'label.qr.code'" [manualBackEvent]="true"
    (onManualBackEvent)="onQrPopupBack()"></app-mobile-header>
  <app-barcode-qrcode [qrCodeValue]="qrCodeValue" [barCodeValue]="barCodeValue"
    [ngClass]="{'QR-image-rotate' : isRotate}" [isShowDesc]="false"
    [barCodeWidth]="qrCodeValue ? '300px' : '400px'" [barCodeHeight]="'150px'"
    [QrWidth]="barCodeValue ? '216px' : '280px'" [QrHeight]="barCodeValue ? '216px' : '280px'"></app-barcode-qrcode>
</p-dialog>

<p-dialog position="center" [(visible)]="displayEnablePermissionDialog" *ngIf="displayEnablePermissionDialog"
  [modal]="true" [dismissableMask]="false" [blockScroll]="true"
  styleClass="centerScreen-dialog displayEnablePermission-dialog">
  <div class="displayEnablePermission-container">
    <img src="assets/generalImage/location.svg">
    <span class="title">{{ 'location.access.denied'| translate}}</span>
    <span class="desc">{{ 'enable.location.permission' | translate}}</span>
    <app-button [textButton]="true" [buttonName]="'button.okay' | translate"
      (click)="displayEnablePermissionDialog = false"></app-button>
  </div>
</p-dialog>
